module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "badges"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "badges__item",
      class: [("badges__item_" + item), {
        current: _vm.curr === index
      }]
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-106c33d2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/slider/badges/Badges.vue
// module id = b8fb525827764d9eb11c
// module chunks = 89